// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-promocode-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: white;
  border-radius: var(--custom-border-radius);
  box-shadow: 0px 0px 42px 0px rgba(0, 0, 0, 0.0705882353);
  padding: 5px 5px;
  margin-bottom: 10px;
}
.add-promocode-wrapper ion-icon {
  width: 22px;
  height: 22px;
}
.add-promocode-wrapper ion-input {
  font-family: AppFont, sans-serif;
  color: #C1C1C1;
}
.add-promocode-wrapper ion-button {
  font-size: 16px;
  --max-height: 48px;
  text-transform: capitalize;
}
.add-promocode-wrapper .name-of-promo {
  display: flex;
  align-items: center;
  min-width: 60%;
  text-align: start;
}
.add-promocode-wrapper .name-of-promo h2, .add-promocode-wrapper .name-of-promo h3 {
  font-size: 16px;
  color: var(--ion-color-secondary);
  font-family: AppFont, sans-serif;
}
.add-promocode-wrapper .name-of-promo h3 {
  font-family: AppFontBold, sans-serif;
  margin-left: 10px;
}
.add-promocode-wrapper .edit_section {
  display: flex;
  align-items: center;
}
.add-promocode-wrapper .edit_section ion-icon {
  height: 30px;
  width: 30px;
  margin-left: 10px;
}

.button {
  background: var(--ion-color-primary);
  color: white;
  font-family: AppFontBold, sans-serif;
  padding: 10px;
  border-radius: 16px;
}

.delete-promo {
  margin-left: 5px;
}

ion-spinner {
  display: block;
  margin: 10px auto;
}

.promo-input {
  --padding-start: 20px;
}

.wraper_name {
  padding-bottom: 15px;
  border-bottom: 2.55px dotted black;
  margin-bottom: 10px;
}
.wraper_name .name {
  font-size: 14px;
  line-height: 20px;
}
.wraper_name .discount {
  font-family: SecondFontBold, sans-serif;
  font-size: 14px;
  line-height: 20px;
}

.title {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 15px;
  letter-spacing: 0em;
  text-align: left;
  color: #000;
}

.promo-icon-button {
  height: 20px;
  width: 20px;
  padding: 5px;
  border: 2px solid red;
}

.border-line {
  border: 1px solid #000000;
}`, "",{"version":3,"sources":["webpack://./src/app/components/promo-code/promo-code.component.scss"],"names":[],"mappings":"AACA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,0CAAA;EACA,wDAAA;EACA,gBAAA;EAcA,mBAAA;AAbD;AAAC;EACC,WAAA;EACA,YAAA;AAEF;AAAC;EACC,gCAAA;EACA,cAAA;AAEF;AAAC;EACC,eAAA;EACA,kBAAA;EACA,0BAAA;AAEF;AACC;EACC,aAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;AACF;AAAE;EACC,eAAA;EACA,iCAAA;EACA,gCAAA;AAEH;AAAE;EACC,oCAAA;EACA,iBAAA;AAEH;AACC;EACC,aAAA;EACA,mBAAA;AACF;AAAE;EACC,YAAA;EACA,WAAA;EACA,iBAAA;AAEH;;AAEA;EACC,oCAAA;EACA,YAAA;EAEA,oCAAA;EACA,aAAA;EACA,mBAAA;AAAD;;AAGA;EACC,gBAAA;AAAD;;AAKA;EACC,cAAA;EACA,iBAAA;AAFD;;AAKA;EACC,qBAAA;AAFD;;AAKA;EACC,oBAAA;EACA,kCAAA;EACA,mBAAA;AAFD;AAKC;EACC,eAAA;EACA,iBAAA;AAHF;AAMC;EACC,uCAAA;EACA,eAAA;EACA,iBAAA;AAJF;;AAQA;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AALD;;AAQA;EACC,YAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;AALD;;AAOA;EACC,yBAAA;AAJD","sourcesContent":["\n.add-promocode-wrapper {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tbackground: white;\n\tborder-radius: var(--custom-border-radius);\n\tbox-shadow: 0px 0px 42px 0px #00000012;\n\tpadding: 5px 5px;\n\tion-icon {\n\t\twidth: 22px;\n\t\theight: 22px;\n\t}\n\tion-input {\n\t\tfont-family: AppFont, sans-serif;\n\t\tcolor: #C1C1C1;\n\t}\n\tion-button {\n\t\tfont-size: 16px;\n\t\t--max-height: 48px;\n\t\ttext-transform: capitalize;\n\t}\n\tmargin-bottom: 10px;\n\t.name-of-promo {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tmin-width: 60%;\n\t\ttext-align: start;\n\t\th2,h3 {\n\t\t\tfont-size: 16px;\n\t\t\tcolor: var(--ion-color-secondary);\n\t\t\tfont-family: AppFont,sans-serif;\n\t\t}\n\t\th3 {\n\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\tmargin-left: 10px;\n\t\t}\n\t}\n\t.edit_section {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tion-icon {\n\t\t\theight: 30px;\n\t\t\twidth: 30px;\n\t\t\tmargin-left: 10px;\n\t\t}\n\t}\n}\n.button {\n\tbackground: var(--ion-color-primary);\n\tcolor: white;\n\n\tfont-family: AppFontBold, sans-serif;\n\tpadding: 10px;\n\tborder-radius: 16px;\n}\n\n.delete-promo {\n\tmargin-left: 5px;\n}\n\n\n\nion-spinner {\n\tdisplay: block;\n\tmargin: 10px auto;\n}\n\n.promo-input {\n\t--padding-start: 20px;\n}\n\n.wraper_name {\n\tpadding-bottom: 15px;\n\tborder-bottom: 2.55px dotted black;\n\tmargin-bottom: 10px;\n\n\n\t.name {\n\t\tfont-size: 14px;\n\t\tline-height: 20px;\n\t}\n\n\t.discount {\n\t\tfont-family: SecondFontBold, sans-serif;\n\t\tfont-size: 14px;\n\t\tline-height: 20px;\n\t}\n}\n\n.title {\n\tfont-family: AppFontBold;\n\tfont-size: 14px;\n\tline-height: 15px;\n\tletter-spacing: 0em;\n\ttext-align: left;\n\tcolor: #000;\n}\n\n.promo-icon-button {\n\theight: 20px;\n\twidth: 20px;\n\tpadding: 5px;\n\tborder: 2px solid red;\n}\n.border-line {\n\tborder: 1px solid #000000;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
